import { createReduxActionTypes } from '../../../utils/actionFactory';

const SET_EXTERNAL_NO_RANGES = 'SET_EXTERNAL_NO_RANGES';
const RESET_EXTERNAL_NO_RANGES = 'RESET_EXTERNAL_NO_RANGES';
const SET_COLUMNS = 'SET_COLUMNS';
const SET_MAIN_SELECTED = 'SET_MAIN_SELECTED';
const SET_EXTERNAL_RANGE_FILTER = 'SET_EXTERNAL_RANGE_FILTER';
const SET_REFRESH = 'SET_REFRESH';
const SET_IS_CONNECT_RANGES_TABLE = 'SET_IS_CONNECT_RANGES_TABLE';

export const actionTypes = createReduxActionTypes('EXTERNAL_NO_RANGES', [
  SET_EXTERNAL_NO_RANGES,
  RESET_EXTERNAL_NO_RANGES,
  SET_COLUMNS,
  SET_MAIN_SELECTED,
  SET_EXTERNAL_RANGE_FILTER,
  SET_REFRESH,
  SET_IS_CONNECT_RANGES_TABLE
]);

const DEFAULT_STATE = {
  externalNoRanges: [],
  connectRanges: [],
  columns: [],
  networkOptions: {},
  mainSelected: 'all',
  externalRangeFilter: 'all',
  refresh: false,
  isConnectRangesTable: false
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[SET_EXTERNAL_NO_RANGES]: {
      const { externalNoRanges, networkOptions, connectRanges } = action;
      return { ...state, externalNoRanges, networkOptions, connectRanges };
    }
    case actionTypes[SET_COLUMNS]: {
      return { ...state, columns: [...action.columns] };
    }
    case actionTypes[SET_MAIN_SELECTED]: {
      return { ...state, mainSelected: action.selected };
    }
    case actionTypes[SET_EXTERNAL_RANGE_FILTER]: {
      return { ...state, externalRangeFilter: action.externalRangeFilter };
    }
    case actionTypes[SET_REFRESH]: {
      return { ...state, refresh: action.refresh };
    }
    case actionTypes[SET_IS_CONNECT_RANGES_TABLE]: {
      return { ...state, isConnectRangesTable: action.isConnectRangesTable };
    }
    case actionTypes[RESET_EXTERNAL_NO_RANGES]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  setExternalNoRanges: (externalNoRanges, networkOptions, connectRanges) => ({
    type: actionTypes[SET_EXTERNAL_NO_RANGES],
    externalNoRanges,
    networkOptions,
    connectRanges
  }),
  setColumns: columns => ({
    type: actionTypes[SET_COLUMNS],
    columns
  }),
  setMainSelected: selected => ({
    type: actionTypes[SET_MAIN_SELECTED],
    selected
  }),
  setExternalRangeFilter: externalRangeFilter => ({
    type: actionTypes[SET_EXTERNAL_RANGE_FILTER],
    externalRangeFilter
  }),
  setRefresh: refresh => ({ type: actionTypes[SET_REFRESH], refresh }),
  setIsConnectRangesTable: isConnectRangesTable => ({
    type: actionTypes[SET_IS_CONNECT_RANGES_TABLE],
    isConnectRangesTable
  }),
  resetExternalNoRanges: () => ({
    type: actionTypes[RESET_EXTERNAL_NO_RANGES]
  })
};
